import { render, staticRenderFns } from "./FacilityEdit.vue?vue&type=template&id=c8bf679a&scoped=true&lang=pug"
import script from "./FacilityEdit.vue?vue&type=script&lang=ts"
export * from "./FacilityEdit.vue?vue&type=script&lang=ts"
import style0 from "./FacilityEdit.vue?vue&type=style&index=0&id=c8bf679a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8bf679a",
  null
  
)

export default component.exports